import React from "react";
import { LegacyEmailComponentType } from "./EmailComponents.type";

export const SubmissionDeadlineExtensionEmailContent: React.FC<
	LegacyEmailComponentType
> = ({ date, projectTitle, rfqTitle, time, timeZone, additionalMessage }) => {
	return (
		<div>
			<svg
				width="664"
				height="224"
				viewBox="0 0 664 224"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_55_12)">
					<mask
						id="mask0_55_12"
						style={{ maskType: "luminance" }}
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="664"
						height="224"
					>
						<path
							d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask0_55_12)">
						<path
							d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
							fill="#003CE9"
						/>
						<path
							d="M667.718 -241C680.248 -161.57 663.646 15.6318 497 89"
							stroke="#708FFB"
							stroke-width="1.5"
						/>
						<path
							d="M497 96C500.866 96 504 92.866 504 89C504 85.134 500.866 82 497 82C493.134 82 490 85.134 490 89C490 92.866 493.134 96 497 96Z"
							fill="#4864F9"
						/>
						<path
							d="M329.001 72.0001H318.001M317.832 72.5831L313.162 86.5325C312.795 87.6283 312.611 88.1763 312.743 88.5137C312.857 88.8067 313.103 89.0289 313.406 89.1135C313.755 89.2108 314.282 88.9737 315.336 88.4995L348.758 73.4592C349.787 72.9963 350.301 72.7648 350.46 72.4433C350.599 72.1639 350.599 71.8362 350.46 71.5569C350.301 71.2353 349.787 71.0039 348.758 70.541L315.324 55.4955C314.273 55.0227 313.748 54.7863 313.399 54.8833C313.097 54.9675 312.851 55.1891 312.736 55.4816C312.604 55.8183 312.786 56.3651 313.149 57.4586L317.833 71.5711C317.895 71.7589 317.926 71.8528 317.939 71.9489C317.95 72.0341 317.949 72.1204 317.938 72.2056C317.926 72.3016 317.894 72.3954 317.832 72.5831Z"
							stroke="#DEEBFF"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M-82 31L80 194"
							stroke="#708FFB"
							stroke-width="1.5"
						/>
						<path
							d="M80 201C83.866 201 87 197.866 87 194C87 190.134 83.866 187 80 187C76.134 187 73 190.134 73 194C73 197.866 76.134 201 80 201Z"
							fill="#4864F9"
						/>
						<path
							d="M154.076 164V118.4H167.396L170.996 122V140.96L167.816 144.14L171.416 164H165.836L162.296 144.56H159.836V164H154.076ZM164.036 139.88L165.236 138.68V124.4L164.036 123.2H159.836V139.88H164.036ZM187.893 118.4V123.32H179.613V138.98H187.053V143.9H179.613V164H173.853V118.4H187.893ZM200.39 140.78L207.17 164H201.41L197.39 149.24L193.55 164H188.03L194.81 140.78L188.33 118.4H194.09L197.75 132.68L201.35 118.4H206.87L200.39 140.78ZM229.866 118.4L233.466 122V160.4L229.866 164H216.366V118.4H229.866ZM226.506 159.08L227.706 157.88V124.52L226.506 123.32H222.126V159.08H226.506ZM236.025 164V118.4H250.245V123.32H241.785V138.44H249.165V143.36H241.785V159.08H250.365V164H236.025ZM262.968 152.24H257.688L256.548 164H250.788L256.248 118.4H264.528L270.108 164H264.108L262.968 152.24ZM262.548 147.32L260.328 124.34L258.108 147.32H262.548ZM284.918 118.4L288.518 122V160.4L284.918 164H271.418V118.4H284.918ZM281.558 159.08L282.758 157.88V124.52L281.558 123.32H277.178V159.08H281.558ZM304.458 164H291.078V118.4H296.838V159.08H304.458V164ZM305.815 164V118.4H311.575V164H305.815ZM314.342 164V118.4H320.582L327.182 150.02V118.4H332.402V164H326.162L319.562 132.86V164H314.342ZM335.173 164V118.4H349.393V123.32H340.933V138.44H348.313V143.36H340.933V159.08H349.513V164H335.173ZM359.785 164V118.4H374.005V123.32H365.545V138.44H372.925V143.36H365.545V159.08H374.125V164H359.785ZM386.967 140.78L393.747 164H387.987L383.967 149.24L380.127 164H374.607L381.387 140.78L374.907 118.4H380.667L384.327 132.68L387.927 118.4H393.447L386.967 140.78ZM410.359 123.2H404.899V164H399.139V123.2H393.679V118.4H410.359V123.2ZM411.673 164V118.4H425.893V123.32H417.433V138.44H424.813V143.36H417.433V159.08H426.013V164H411.673ZM427.875 164V118.4H434.115L440.715 150.02V118.4H445.935V164H439.695L433.095 132.86V164H427.875ZM458.547 131.6V124.4L457.347 123.2H455.247L454.047 124.4V137.24L455.247 138.44H460.887L464.487 142.04V160.4L460.887 164H451.767L448.167 160.4V150.86H453.927V158L455.127 159.2H457.527L458.727 158V144.56L457.527 143.36H451.887L448.287 139.76V122L451.887 118.4H460.707L464.307 122V131.6H458.547ZM466.725 164V118.4H472.485V164H466.725ZM492.292 122V160.4L488.692 164H478.672L475.072 160.4V122L478.672 118.4H488.692L492.292 122ZM485.332 123.32H482.032L480.832 124.52V157.88L482.032 159.08H485.332L486.532 157.88V124.52L485.332 123.32ZM494.853 164V118.4H501.093L507.693 150.02V118.4H512.913V164H506.673L500.073 132.86V164H494.853Z"
							fill="white"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_55_12">
						<rect
							width="664"
							height="224"
							fill="white"
						/>
					</clipPath>
				</defs>
			</svg>

			<div className="mt-10">
				<strong>
					Subject:
					{projectTitle} and {rfqTitle} Submission Deadline Extension
				</strong>
			</div>
			<div>
				<p className="py-5">Dear [Participant's Name/Team],</p>
				<p className="py-2">
					We’d like to inform you that the deadline for the the RFx submission
					has been extended to{" "}
					<b>
						{date} {time} {timeZone}
					</b>
				</p>
				<p>Additional Message:</p>
				<p>{additionalMessage}</p>
				<p className="py-2">
					Please don’t hesitate to reach out if you have any questions. We look
					forward to reviewing your submission by the new date.
					<p className="py-1">Best regards,</p>
					<p className="py-1">[Your Name]</p>
					<p className="py-1">[Your Position]</p>
				</p>
			</div>
		</div>
	);
};
